export default __webpack_public_path__ + "static/bratz-x-bb-mobile-0641ebe2c68c2661bc6912f7dabac0b3.webp";